import React from "react";
import _ from "lodash";

import { connect } from "react-redux";
import { Platform } from "react-native";
import { withTranslation } from "react-i18next";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/studyletter/PracticeRedux";
import { NavigationService } from "../../navigation";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import UIDs from "../../UIDs";
import ResultViews from "../homework/resultViews";
import * as Helper from "../../utils/Helper";

const uid = UIDs.screens.studyletter.practiceresult;

let t;
class PracticeResultScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_PRACTICE_RESULT_ASYNC]: { done: this._handleLoadScreenViewAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.UPDATE_LOCAL_RESULT_ASYNC]: { done: this._handleUpdateLocalResultAsyncDone, error: this._handleUpdateLocalResultAsyncError },
            [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: { done: this._handleUpdateUnitResultAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);
        t = props.t;

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        let { letter, pageIndex, unitId, practiceRole, result } = this.props;
        this.props.loadPracticeResultAsync({ letter, pageIndex, unitId, practiceRole, result });
    }

    refreshScreen() {
        let { letter, pageIndex, unitId, practiceRole, result } = this.props;
        this.props.loadPracticeResultAsync({ letter, pageIndex, unitId, practiceRole, result });
    }

    renderScreen() {
        const { data, result } = this.props.localState;

        if (!this.isActionDone(ActionTypes.LOAD_PRACTICE_RESULT_ASYNC)) return <LoadingIndicator />;

        const ResultView = ResultViews[data.unitType];

        return <ResultView {...this.props} data={data} result={result} onReportResult={this._handleReportResult} goToRanking={this._gotoRanking} />
    }

    _gotoRanking = () => {
        const { unitId, practiceRole } = this.props;
        NavigationService.navigateToPage(this, UIDs.screens.studyletter.ranking, { unitId, practiceRole });
    }

    _handleReportResult = (unitResult) => {
        if (unitResult.answer) unitResult.answer = Helper.convertAnswerToJson(unitResult.answer);

        let { unitId, practiceRole } = this.props;
        unitResult = { ...unitResult, unitId, practiceRole };

        this.props.updateLocalResultAsync(unitResult);
    };

    _handleLoadScreenViewAsyncDone = () => {
        // const { data } = this.props.localState;
        // const { vipEnabled } = data;
        // if (!vipEnabled) {
        //     NavigationService.navigateToPage(this, UIDs.screens.me.member);
        // }
    };

    _handleUpdateLocalResultAsyncDone = action => {
        this.props.updateUnitResultAsync(action.data);
    };

    _handleUpdateLocalResultAsyncError = action => {
        this.displayAsyncActionError(action.error, "unitResultUpdateFailure");
    };

    _handleUpdateUnitResultAsyncDone = action => {
        // const { canUpgrade, currentBookName, nextBookName, nextBookId } = action.data;
        // if (canUpgrade) {
        //     NavigationService.navigateToPage(this, UIDs.screens.studyletter.complete, { canUpgrade, current: currentBookName, next: nextBookName, nextId: nextBookId });
        // }
    };

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadPracticeResultAsync: (vo) => dispatch(Actions.loadPracticeResultAsync(vo)),
        updateLocalResultAsync: vo => dispatch(Actions.updateLocalResultAsync(vo)),
        updateUnitResultAsync: (unitResult) => dispatch(Actions.updateUnitResultAsync(unitResult)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(uid)(PracticeResultScreen));
